// extracted by mini-css-extract-plugin
export default {"backdrop":"ViewImage_backdrop__J-zqF","popup_container":"ViewImage_popup_container__+GeEk","popup_container__inr__description":"ViewImage_popup_container__inr__description__aEmns"};